/* GENERATED FILE — do not edit.
   Source: shared-ui/ui/Panel.js
   Run "node shared-ui/sync.js" after editing the source. */
import React from 'react';

/**
 * Card shell from the approved deck.
 * <Panel title="Top Countries" subtitle="194 players" actions={<Btn/>}>...</Panel>
 */
export default function Panel({ title, subtitle, actions, children, className, ...rest }) {
  const hasHead = title || subtitle || actions;

  return (
    <section className={className ? 'panel ' + className : 'panel'} {...rest}>
      {hasHead ? (
        <div className="p-head">
          <div className="p-headline">
            {title ? <h2 className="p-title">{title}</h2> : null}
            {subtitle ? <div className="p-sub">{subtitle}</div> : null}
          </div>
          {actions ? <div className="p-tools">{actions}</div> : null}
        </div>
      ) : null}

      <div className="p-body">{children}</div>
    </section>
  );
}
